import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { tap } from 'rxjs';
import { Store } from '@ngrx/store';

import { selectSocialMedia } from '@public-page/store/company';

@Component({
  selector: 'pub-social-media',
  templateUrl: './social-media.component.html',
  styleUrls: ['./social-media.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialMediaComponent {
  @HostBinding('class.hide-component') isHide = false;

  $socialMedia = this.store
    .select(selectSocialMedia)
    .pipe(tap((socialMedia) => (this.isHide = socialMedia.length === 0)));

  constructor(private store: Store) {}
}
